// client/src/modules/recruiting/nav.ts
import type { NavItem } from '../types';

/**
 * Navigation items for Recruiting module
 *
 * Grouped around the recruiter's two kinds of work (the grouping Nick wrote down in ISS-633), with the screen a recruiter lives on first:
 * - Dashboard: where they start
 * - Candidates & Pipeline: the candidate work — the Candidates list and the Pipeline board (named so the group and its child are not both "Pipeline")
 * - Setup: the funnel behind it — Jobs, Job Templates, Partners, Talent Pools, Sequences and how outreach is doing
 *
 * Nine flat items became three. Every page is still one click (a dropdown) away, and every path is unchanged, so bookmarks and links
 * keep working. A group's own link goes to its first page.
 */
export const navItems: NavItem[] = [
  { label: 'Dashboard', path: '/recruiting' },
  {
    label: 'Candidates & Pipeline',
    path: '/recruiting/candidates',
    children: [
      { label: 'Candidates', path: '/recruiting/candidates' },
      { label: 'Pipeline', path: '/recruiting/pipeline' },
    ],
  },
  {
    label: 'Setup',
    path: '/recruiting/jobs',
    children: [
      { label: 'Jobs', path: '/recruiting/jobs' },
      { label: 'Job Templates', path: '/recruiting/job-templates' },
      { label: 'Partners', path: '/recruiting/partners' },
      { label: 'Talent Pools', path: '/recruiting/talent-pools' },
      { label: 'Sequences', path: '/recruiting/sequences' },
      { label: 'Outreach Analytics', path: '/recruiting/outreach-analytics' },
    ],
  },
];
